module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('model-crud', {
    attrs: {
      "model": _vm.model,
      "fields": _vm.fields,
      "include": ['creator'],
      "editable": false,
      "deletable": false,
      "default-order": "created",
      "default-order-asc": false
    },
    scopedSlots: _vm._u([{
      key: "creator",
      fn: function(row) {
        return [_c('div', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: row.item.creator ? ((row.item.creator.name) + " " + (row.item.creator.surname)) : '?'
            }),
            expression: "{ content: row.item.creator ? `${row.item.creator.name} ${row.item.creator.surname}` : '?' }"
          }]
        }, [_vm._v("\n      " + _vm._s(row.item.creator ? row.item.creator.username : '?') + "\n    ")])]
      }
    }, {
      key: "dataBefore",
      fn: function(row) {
        return [_c('div', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.formatDataTooltip(_vm.model.getDiff(row.item, 'dataBefore'))
            }),
            expression: "{ content: formatDataTooltip(model.getDiff(row.item, 'dataBefore')) }"
          }]
        }, [_vm._v("\n      " + _vm._s(_vm.formatData(_vm.model.getDiff(row.item, 'dataBefore'))) + "\n    ")])]
      }
    }, {
      key: "dataAfter",
      fn: function(row) {
        return [_c('div', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.formatDataTooltip(_vm.model.getDiff(row.item, 'dataAfter'))
            }),
            expression: "{ content: formatDataTooltip(model.getDiff(row.item, 'dataAfter')) }"
          }]
        }, [_vm._v("\n      " + _vm._s(_vm.formatData(_vm.model.getDiff(row.item, 'dataAfter'))) + "\n    ")])]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a6cf4a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Reports/DataChanges.vue
// module id = 1062
// module chunks = 1